import { isEditor } from '@core/util/util.isEditor';
import { getRoleOverride } from '@frontend/components/RoleSelector';
import {
  useDirectoryMe,
  useDirectoryTeam,
} from '@frontend/shared/hooks/useDirectory';

export function useIsEditor() {
  const me = useDirectoryMe();
  const team = useDirectoryTeam();

  // Check for dev role override
  const roleOverride = getRoleOverride();
  if (roleOverride === 'admin' || roleOverride === 'editor') return true;
  if (roleOverride === 'viewer') return false;

  return isEditor(team, me.id);
}
